import api from "src/apis/api"

// notable: "leads" | "deals" | "bookings"; id: parent id.
function basePath(notable, id) {
  return `/api/v1/${notable}/${id}/notes`
}

export async function fetchNotes(notable, id) {
  const { data } = await api.get(basePath(notable, id))
  return data.notes || []
}

export async function createNote(notable, id, body) {
  const { data } = await api.post(basePath(notable, id), { note: { body } })
  return data.note
}

export async function deleteNote(notable, id, noteId) {
  const { data } = await api.delete(`${basePath(notable, id)}/${noteId}`)
  return data
}
